import React from "react";
import PropTypes from "prop-types";
import { StoryCard } from "../basic/story-card.js";
import { StoryList } from "../basic/story-list.js";
import { CollectionName } from "../atoms/collection-name/index.js";
import { AdService } from "../ad-service";
import { isEager, getRowMetadata } from "../../utils";

import { wrapCollectionLayout } from "@quintype/components";

function ThreeColBase({ collection, config, associatedMetadata, stories, index }) {
  const firstStoryCardConfig = {
    image: true,
    imageAspectRatio: [2, 3],
    imageWidth: [400]
  };
  const secondStoryCardConfig = {
    image: true,
    imageAspectRatio: [16, 9],
    imageWidth: [400]
  };
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);

  const { show_collection_title: collectionName = true } = pbAheadConfig;
  return (
    <div className="three-col component-wrapper" data-test-id="three-col-component">
      {collectionName ? <CollectionName name={collection.name} config={config} section={collection} /> : null}
      <div className="three-col__items">
        <div className="three-col__item full-image">
          <StoryCard
            eager={isEager(index, true)}
            hideSectionName={true}
            story={stories[0]}
            type="imageBackground"
            config={firstStoryCardConfig}
          />
        </div>
        <div className="three-col__item two-stories">
          <StoryCard eager={isEager(index)} hideSectionName={true} story={stories[1]} config={secondStoryCardConfig} />
          <StoryCard hideSectionName={true} story={stories[2]} />
        </div>
        <div className="three-col__item">
          <StoryList stories={stories.slice(3, 8)} />
        </div>
      </div>
      <div className="app-ad app-ad--horizontal">
        <AdService
          adtype="Horizontal-Ad"
          layoutName="ThreeCol"
          collectionSlug={collection.slug}
          slotId={`ThreeCol-${index}`}
        />
      </div>
    </div>
  );
}

ThreeColBase.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
  associatedMetadata: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export const ThreeCol = wrapCollectionLayout(ThreeColBase);
